export default "__VITE_ASSET__UXmtxYZ9__"